import { render } from "./teacherrecord.vue?vue&type=template&id=b380ecce"
import script from "./teacherrecord.vue?vue&type=script&lang=js"
export * from "./teacherrecord.vue?vue&type=script&lang=js"
script.render = render

export default script